/*
 * 模块: 上传执行器
 * 职责: 执行批量上传和处理结果
 * 依赖: API, 类型定义
 * 导出: 上传执行函数
 * 限制: 文件<280行, 函数<30行
 */

import type { FileInfo, UploadResult } from '../../types';
import type { ProgressUpdater } from './fileProcessor';

/**
 * 批量上传API响应
 */
export interface BatchUploadResponse {
  batchResults: any[];
  taskId?: string;
}

/**
 * 批量上传函数类型
 */
export type BatchUploader = (formData: FormData) => Promise<{
  data: {
    results?: any[];
    task_id?: string;
  };
}>;

/**
 * 执行批量上传
 */
export const performBatchUpload = async (
  fileInfos: FileInfo[],
  skuId: number,
  uploadFn: BatchUploader,
  updateProgress: ProgressUpdater
): Promise<BatchUploadResponse> => {
  // 标记所有文件为上传中
  fileInfos.forEach(({ file }) => {
    updateProgress(file.name, '上传中...');
  });

  // 构建批量上传表单
  const formData = new FormData();
  formData.append('sku_id', skuId.toString());
  formData.append('period_mode', 'filename');
  formData.append('quick_mode', 'true');

  fileInfos.forEach(({ file }) => {
    formData.append('files', file);
  });

  const response = await uploadFn(formData);
  return {
    batchResults: response.data.results || [],
    taskId: response.data.task_id
  };
};

/**
 * 处理上传结果
 */
export const processBatchResults = (
  batchResults: any[],
  results: UploadResult[],
  updateProgress: ProgressUpdater
): void => {
  batchResults.forEach((result: any) => {
    const fileName = result.file;

    if (result.status === 'success') {
      updateProgress(fileName, `✓ ${result.week_number} (处理中...)`);
      results.push({
        file: fileName,
        success: true,
        message: result.message || `成功上传到 ${result.week_number}`
      });
    } else {
      updateProgress(fileName, '❌ 失败');
      const errors = result.errors || ['未知错误'];
      results.push({
        file: fileName,
        success: false,
        message: errors.join('; ')
      });
    }
  });
};

